import { useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import PowiatService from '@/services/PowiatService'

export default function usePowiatModal(loadData) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingItem, setEditingItem] = useState(null)
	const [formName, setFormName] = useState('')
	const [formWojewodztwoId, setFormWojewodztwoId] = useState(null)
	const [formWojewodztwoName, setFormWojewodztwoName] = useState('')
	const [isSaving, setIsSaving] = useState(false)
	const [isWojewodztwoSelectOpen, setIsWojewodztwoSelectOpen] = useState(false)

	const openCreateModal = () => {
		setEditingItem(null)
		setFormName('')
		setFormWojewodztwoId(null)
		setFormWojewodztwoName('')
		setIsModalOpen(true)
	}

	const openEditModal = item => {
		setEditingItem(item)
		setFormName(item?.nazwa || '')
		const wojewodztwoValue = item?.id_wojewodztwo
		const wojewodztwoId =
			typeof wojewodztwoValue === 'object'
				? wojewodztwoValue?._id || wojewodztwoValue?.id || null
				: wojewodztwoValue || null
		const wojewodztwoName =
			typeof wojewodztwoValue === 'object' ? wojewodztwoValue?.nazwa || '' : ''
		setFormWojewodztwoId(wojewodztwoId)
		setFormWojewodztwoName(wojewodztwoName)
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setEditingItem(null)
		setFormName('')
		setFormWojewodztwoId(null)
		setFormWojewodztwoName('')
		setIsWojewodztwoSelectOpen(false)
		setIsSaving(false)
	}

	const openWojewodztwoSelectModal = () => {
		setIsWojewodztwoSelectOpen(true)
	}

	const closeWojewodztwoSelectModal = () => {
		setIsWojewodztwoSelectOpen(false)
	}

	const applyWojewodztwoSelection = (wojewodztwoId, wojewodztwoName) => {
		setFormWojewodztwoId(wojewodztwoId || null)
		setFormWojewodztwoName(wojewodztwoName || '')
		setIsWojewodztwoSelectOpen(false)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const name = formName.trim()
		if (!name || !formWojewodztwoId) return

		setIsSaving(true)
		const result = editingItem?._id
			? await PowiatService.update(editingItem._id, { nazwa: name, id_wojewodztwo: formWojewodztwoId })
			: await PowiatService.create({ nazwa: name, id_wojewodztwo: formWojewodztwoId })

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zapisac powiatu',
				icon: 'error',
			})
			setIsSaving(false)
			return
		}

		closeModal()
		await loadData()
	}

	const handleDelete = async item => {
		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text: `Usunac powiat "${item?.nazwa || '-'}"?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		const result = await PowiatService.delete(item?._id)
		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac powiatu',
				icon: 'error',
			})
			return
		}

		await loadData()
	}

	const buttons = useMemo(
		() => [
			{
				type: 'add',
				label: 'Dodaj nowe',
				onClick: openCreateModal,
			},
		],
		[]
	)

	return {
		isModalOpen,
		editingItem,
		formName,
		setFormName,
		formWojewodztwoId,
		formWojewodztwoName,
		isSaving,
		isWojewodztwoSelectOpen,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		openWojewodztwoSelectModal,
		closeWojewodztwoSelectModal,
		applyWojewodztwoSelection,
		buttons,
	}
}
